import { AfterCrop } from "./AfterCrop";

interface Props {
  previewUrl: string;
  emoji: string;
  title: string;
  description: string;
  onClick: () => void;
  disabled?: boolean;
}

export function ActionCard({
  previewUrl,
  emoji,
  title,
  description,
  onClick,
  disabled = false,
}: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="w-full text-left flex items-center gap-3.5 active:scale-[0.99] transition disabled:opacity-50"
      style={{
        background: "var(--color-sk-card)",
        border: "1px solid var(--color-sk-line)",
        borderRadius: 18,
        padding: 10,
      }}
    >
      <AfterCrop
        src={previewUrl}
        aspect={1}
        radius={12}
        style={{ width: 116, flexShrink: 0 }}
      />
      <div className="flex-1 min-w-0">
        <div
          style={{
            fontSize: 17,
            fontWeight: 600,
            letterSpacing: -0.2,
            color: "var(--color-sk-text)",
            marginBottom: 5,
          }}
        >
          {emoji} {title}
        </div>
        <div
          style={{
            fontSize: 13,
            color: "var(--color-sk-text-mute)",
            lineHeight: 1.4,
          }}
        >
          {description}
        </div>
      </div>
    </button>
  );
}
